import { Box, Typography } from "@material-ui/core";
import { Mode, Note, getScale } from "../util/keys";

export type Props = {
    tonic: Note
    mode: Mode
}

const Scale: React.FC<Props> = ({ tonic, mode }) => {
    const scale = getScale(tonic, mode)
    return <Box display="flex">{scale.map(note => <Box textAlign="center" margin={1} key={note}>
        <Box padding={1}><Typography>{note}</Typography></Box>
    </Box>)}</Box>
}

export default Scale;